// extracted by mini-css-extract-plugin
export default {"messsage_box":"MessagesBox_messsage_box__tGoTr","messages_container":"MessagesBox_messages_container__HfSLm"};